<template>
    <div>
      <commonIndex :tjType="2" />
    </div>
</template>
           
<script>
import commonIndex from '../commonIndex.vue'
export default {
  components:{
    commonIndex
  },
  data(){
    return {
      
    }
  }
    

}
</script>
<style scoped>
            
</style>